import React from 'react';
import { Form, Typography } from 'antd';

function AntdValuePreview({ form, dependencies = [], show = false }) {
	const frontendBaseUrl = import.meta.env.VITE_FRONTEND_BASE_URL;
	console.log(frontendBaseUrl, 'BASE URL');
	return (
		<>
			{frontendBaseUrl === 'http://localhost:3000' && show && (
				<Form.Item noStyle dependencies={dependencies}>
					{() => {
						return (
							<Typography>
								<pre
									style={{
										overflow: 'auto',
										resize: 'vertical',
										height: '100px',
										minHeight: '100px',
										minWidth: '200px',
										padding: '8px',
										border: '1px solid #d9d9d9',
										borderRadius: '4px',
										background: '#fafafa',
										fontFamily: 'monospace',
									}}
								>
									{JSON.stringify(form?.getFieldsValue(true), null, 2)}
								</pre>
							</Typography>
						);
					}}
				</Form.Item>
			)}
		</>
	);
}

export default AntdValuePreview;
